const FreightModeBaseTypes = {
  AIR: "air",
  OCEAN: "ocean",
  PARCEL: "parcel",
  RAIL: "rail",
  ROAD: "road",
} as const;

export default FreightModeBaseTypes;
